import React, { useState, lazy } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, CheckIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    }, 1500);
  };
  return <div className="w-full pt-20" data-id="element-316">
      {/* Hero Section */}
      <section className="relative py-20 bg-gray-900" data-id="element-317">
        <div className="absolute inset-0 z-0 opacity-30" data-id="element-318">
          <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80" alt="Contact us" className="w-full h-full object-cover" data-id="element-319" />
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-320">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-321">
            Contact Us
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-322">
            Get in touch with our team to discuss your project needs
          </p>
        </div>
      </section>
      {/* Contact Information & Form */}
      <section className="py-20" data-id="element-323">
        <div className="container mx-auto px-4 md:px-6" data-id="element-324">
          <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-325">
            {/* Contact Information */}
            <div data-id="element-326">
              <h2 className="text-3xl font-bold text-[#1a2e1a] mb-6" data-id="element-327">
                Get In Touch
              </h2>
              <p className="text-lg text-gray-700 mb-8" data-id="element-328">
                Have questions about our services or want to discuss a potential
                project? Contact us using the information below or fill out the
                form, and our team will get back to you as soon as possible.
              </p>
              <div className="space-y-6 mb-10" data-id="element-329">
                <div className="flex items-start" data-id="element-330">
                  <div className="bg-[#e9f5cc] p-3 rounded-full text-[#95c11f] mr-4" data-id="element-331">
                    <MapPinIcon size={24} data-id="element-332" />
                  </div>
                  <div data-id="element-333">
                    <h3 className="font-bold text-[#1a2e1a] mb-1" data-id="element-334">
                      Abuja Office
                    </h3>
                    <p className="text-gray-700" data-id="element-335">
                      12D Sherri Hills Crescent,
                      <br data-id="element-336" />
                      Hall 7, Imperial Vista Estate,
                      <br data-id="element-337" />
                      Kafe district, Life camp, Abuja.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-338">
                  <div className="bg-[#e9f5cc] p-3 rounded-full text-[#95c11f] mr-4" data-id="element-339">
                    <MapPinIcon size={24} data-id="element-340" />
                  </div>
                  <div data-id="element-341">
                    <h3 className="font-bold text-[#1a2e1a] mb-1" data-id="element-342">
                      Benin Office
                    </h3>
                    <p className="text-gray-700" data-id="element-343">
                      11, Airiofolo avenue, off Irhirhi,
                      <br data-id="element-344" />
                      Off Airport road, Benin City.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-345">
                  <div className="bg-[#e9f5cc] p-3 rounded-full text-[#95c11f] mr-4" data-id="element-346">
                    <PhoneIcon size={24} data-id="element-347" />
                  </div>
                  <div data-id="element-348">
                    <h3 className="font-bold text-[#1a2e1a] mb-1" data-id="element-349">Phone</h3>
                    <p className="text-gray-700" data-id="element-350">07014383978</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-351">
                  <div className="bg-[#e9f5cc] p-3 rounded-full text-[#95c11f] mr-4" data-id="element-352">
                    <MailIcon size={24} data-id="element-353" />
                  </div>
                  <div data-id="element-354">
                    <h3 className="font-bold text-[#1a2e1a] mb-1" data-id="element-355">Email</h3>
                    <p className="text-gray-700" data-id="element-356">
                      info@socratesandrichards.com
                      <br data-id="element-357" />
                      projects@socratesandrichards.com
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-358">
                <h3 className="font-bold text-[#1a2e1a] mb-3" data-id="element-359">Follow Us</h3>
                <div className="flex space-x-4" data-id="element-360">
                  <a href="https://facebook.com" className="bg-gray-200 hover:bg-[#e9f5cc] text-gray-700 hover:text-[#95c11f] p-3 rounded-full transition-colors" aria-label="Facebook" data-id="element-361">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-362">
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-363"></path>
                    </svg>
                  </a>
                  <a href="https://instagram.com" className="bg-gray-200 hover:bg-[#e9f5cc] text-gray-700 hover:text-[#95c11f] p-3 rounded-full transition-colors" aria-label="Instagram" data-id="element-364">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-365">
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-366"></rect>
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-367"></path>
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-368"></line>
                    </svg>
                  </a>
                  <a href="https://linkedin.com" className="bg-gray-200 hover:bg-[#e9f5cc] text-gray-700 hover:text-[#95c11f] p-3 rounded-full transition-colors" aria-label="LinkedIn" data-id="element-369">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-370">
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-371"></path>
                      <rect x="2" y="9" width="4" height="12" data-id="element-372"></rect>
                      <circle cx="4" cy="4" r="2" data-id="element-373"></circle>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            {/* Contact Form */}
            <div className="bg-white rounded-lg shadow-xl p-8" data-id="element-374">
              <h2 className="text-2xl font-bold text-[#1a2e1a] mb-6" data-id="element-375">
                Send Us a Message
              </h2>
              {isSubmitted ? <div className="text-center py-8" data-id="element-376">
                  <div className="bg-[#e9f5cc] text-[#95c11f] rounded-full p-3 inline-flex mb-4" data-id="element-377">
                    <CheckIcon size={32} data-id="element-378" />
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2e1a] mb-2" data-id="element-379">
                    Message Sent!
                  </h3>
                  <p className="text-gray-700 mb-6" data-id="element-380">
                    Thank you for contacting us. Our team will get back to you
                    shortly.
                  </p>
                  <button onClick={() => setIsSubmitted(false)} className="text-[#95c11f] font-medium hover:text-[#7ba318] transition-colors" data-id="element-381">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} data-id="element-382">
                  <div className="mb-4" data-id="element-383">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-384">
                      Full Name *
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#95c11f] focus:border-[#95c11f] outline-none transition-colors" placeholder="Your name" required data-id="element-385" />
                  </div>
                  <div className="mb-4" data-id="element-386">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-387">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#95c11f] focus:border-[#95c11f] outline-none transition-colors" placeholder="Your email" required data-id="element-388" />
                  </div>
                  <div className="mb-4" data-id="element-389">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-390">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#95c11f] focus:border-[#95c11f] outline-none transition-colors" placeholder="Your phone number" data-id="element-391" />
                  </div>
                  <div className="mb-6" data-id="element-392">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-393">
                      Message *
                    </label>
                    <textarea id="message" name="message" rows={5} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#95c11f] focus:border-[#95c11f] outline-none transition-colors resize-none" placeholder="How can we help you?" required data-id="element-394"></textarea>
                  </div>
                  <button type="submit" className={`w-full bg-[#95c11f] hover:bg-[#7ba318] text-[#1a2e1a] font-medium py-2.5 px-4 rounded-lg transition-colors ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`} disabled={isSubmitting} data-id="element-395">
                    {isSubmitting ? <span className="flex items-center justify-center" data-id="element-396">
                        <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-397">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-398"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-399"></path>
                        </svg>
                        Sending...
                      </span> : 'Send Message'}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </section>
      {/* Map Section */}
      <section className="py-10" data-id="element-400">
        <div className="container mx-auto px-4 md:px-6" data-id="element-401">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-402">
            <div className="aspect-w-16 aspect-h-9" data-id="element-403">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253682.45932537218!2d3.1191210160364797!3d6.548055351409531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8b2ae68280c1%3A0xdc9e87a367c3d9cb!2sLagos!5e0!3m2!1sen!2sng!4v1623234274421!5m2!1sen!2sng" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Office Location" data-id="element-404"></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Contact;